import { render, staticRenderFns } from "./frontFormResponse.vue?vue&type=template&id=70c339a4&"
import script from "./frontFormResponse.vue?vue&type=script&lang=js&"
export * from "./frontFormResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports